import { DolCard } from '@doltech/ui/lib/figma/Card/DolCard/DolCard';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import styled from 'styled-components';

export const SetupCard = styled(DolCard.Custom)`
  border-radius: 16px;
  padding-bottom: 24px;
`;

export const MainSection = styled.div`
  display: grid;
  row-gap: 16px;
  padding: 24px;
  grid-auto-rows: minmax(0, max-content);

  white-space: pre-wrap;
  word-break: break-word;

  .active-label {
    position: absolute;
    bottom: 12px;
    right: 12px;
  }

  .image-section {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    overflow: hidden;
    background-color: ${colorsV2.gray20};
  }

  .info-section {
    display: grid;
    row-gap: 4px;
    grid-template-columns: minmax(0, calc(100% - 32px));
  }
`;

export const Layout = styled.div`
  display: grid;
  grid-template-rows: 1fr max-content max-content;
  align-items: flex-start;
  height: 100%;
`;
